import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_ALL_VOUCHERS = "[VOUCHERS] GET ALL VOUCHERS"

export const GET_DEFAULT_VOUCHER = "[VOUCHERS] GET DEFAULT VOUCHER"

export const CRUD_VOUCHER = "[VOUCHERS] CRUD VOUCHER"

export const GET_VOUCHERS_FOR_SALE = "[VOUCHERS] GET VOUCHERS FOR SALE"

export function getAllVouchers() {
  const request = api.get(`/comprobante`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_ALL_VOUCHERS, payload: response.data.detalles })
    }).catch((err) => {
      dispatch({ type: GET_ALL_VOUCHERS, payload: [] })
      toast.error("Error inesperado. No se pudo obtener los comprobantes")
      console.log(err)
    })
}

export function getDefaultVoucher() {
  const request = api.get(`/comprobante-por-defecto`)
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: GET_DEFAULT_VOUCHER, payload: response.data.detalles })
    }).catch((error) => {
      dispatch({ type: GET_DEFAULT_VOUCHER, payload: null })
      toast.info("No se pudo consultar un comprobante predeterminado")
      console.log(error)
    })
  }
}

export function saveVoucher(from) {
  const request = api.post(`/comprobante-guardar`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_VOUCHER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo registrar el comprobante")
      console.log(err)
    })
  }
}

export function updateVoucher(from) {
  const request = api.post(`/comprobante-actualizar`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_VOUCHER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo actualizar el comprobante")
      console.log(err)
    })
  }
}

export function deleteVoucher(from) {
  const request = api.post(`/comprobante-eliminar`, from)
  return (dispatch) => {
    toast.info("Borrando comprobante...", { toastId: "deleteVoucher", autoClose: false })
    dispatch({ type: CRUD_VOUCHER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "deleteVoucher", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "deleteVoucher", autoClose: 5000 })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo borrar el comprobante", { toastId: "deleteVoucher", autoClose: 5000 })
      console.log(err)
    })
  }
}

export function updateVoucherStatus(form) {
  const request = api.post(`/comprobante-cambiar-estado`, form)
  return (dispatch) => {
    toast.info("Actualizando estado...", { toastId: "updateVoucherStatus", autoClose: false })
    dispatch({ type: CRUD_VOUCHER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "updateVoucherStatus", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "updateVoucherStatus", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_VOUCHER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo actualizar el estado del comprobante", { toastId: "updateVoucherStatus", autoClose: 5000 })
      console.log(err)
    })
  }
}

export function getVouchersForSale(user = {}) {
  const request = api.post(`/comprobante-para-facturacion`, user)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_VOUCHERS_FOR_SALE, payload: response.data.detalles })
    }).catch((err) => {
      dispatch({ type: GET_VOUCHERS_FOR_SALE, payload: [] })
      toast.error("Error inesperado. No se pudo obtener los comprobantes de facturacion del usuario")
      console.log(err)
    })
}